import LeadingLinks from '../../components/leading-links';
import AsideNavLink from '../../components/aside-nav-link';
import AsideLayout from '../../components/layouts/aside-layout';
import MainLayout from '../../components/layouts/main-layout';
import AsxAnnualReports from '../../components/asx/asx-annual-reports';
import AsxLatestAnnouncement from '../../components/asx/asx-latest-announcement';
import HeroImage from '../../public/img/hero/annual_reports_1920_640.jpg';
import Head from 'next/head';

export default function AnnualReports() {
    return (
        <MainLayout>
            <Head>
                <title>Annual Reports | Solvar</title>
                <meta name="description" content="Solvar annual reports."></meta>
            </Head>
            <AsideLayout
                prev={
                    <LeadingLinks href="/investors/company-announcements" prev>Company Announcements</LeadingLinks>
                }
                heroImage={ HeroImage }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">Investors</span> › Annual Reports
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history">History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors">Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance">Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy">Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability">Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements">Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports" active={true}>Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us">Contact Us</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">Annual Reports</h1>
                <AsxLatestAnnouncement
                    image={(
                        <img src="/img/documents/MNY_Annual_Report_to_shareholders-2025.jpg" alt="Latest Report" />
                    )}
                />
                <AsxAnnualReports />
            </AsideLayout>
        </MainLayout>
    );
}